import React, { useCallback, useContext, useEffect, useState } from 'react';
import { LayerContext } from './layerContext';
export function LayerProvider({ children, zOffset = 0, }) {
    const parent = useContext(LayerContext);
    const zIndex = parent ? parent.zIndex + zOffset : zOffset;
    const [size, setSize] = useState(0);
    const registerChild = useCallback(() => {
        setSize((v) => v + 1);
        return () => setSize((v) => v - 1);
    }, []);
    const parentRegisterChild = parent === null || parent === void 0 ? void 0 : parent.registerChild;
    useEffect(() => {
        if (!parentRegisterChild)
            return;
        return parentRegisterChild();
    });
    return (React.createElement(LayerContext.Provider, { value: { isTopLayer: size === 0, registerChild, size, zIndex } }, children));
}
//# sourceMappingURL=layerProvider.js.map